import { render, staticRenderFns } from "./TEST_WDT.vue?vue&type=template&id=778e6adf&scoped=true"
import script from "./TEST_WDT.vue?vue&type=script&lang=js"
export * from "./TEST_WDT.vue?vue&type=script&lang=js"
import style0 from "./TEST_WDT.vue?vue&type=style&index=0&id=778e6adf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778e6adf",
  null
  
)

export default component.exports